import { render, staticRenderFns } from "./bonus1.vue?vue&type=template&id=98c76076&scoped=true&"
import script from "./bonus1.vue?vue&type=script&lang=js&"
export * from "./bonus1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c76076",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/NewRabbit/newRabbitAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98c76076')) {
      api.createRecord('98c76076', component.options)
    } else {
      api.reload('98c76076', component.options)
    }
    module.hot.accept("./bonus1.vue?vue&type=template&id=98c76076&scoped=true&", function () {
      api.rerender('98c76076', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sysconfig/bonusConfig/bonus1.vue"
export default component.exports